import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Default } from "../../components/Default/Default";
import { ROUTES_APPLICATION_PATH } from "../../routes.constants";
import { SYSTEM_COLORS } from "../../components/system.colors";

const LayersIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
    <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
    <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
  </svg>
);

const SparklesIcon = (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" />
    <path d="M22 5h-4" />
    <path d="M4 17v2" />
    <path d="M5 18H3" />
  </svg>
);

const ArrowIcon = (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

const HUB_CARDS = [
  {
    title: "Qualificação do MIX",
    description: "Ranking de rede por grupo de produto e plano de mix por porte de loja.",
    icon: LayersIcon,
    route: ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[0],
  },
  {
    title: "Novo Mix Sugerido",
    description: "Oportunidades de inclusão e corte sugeridas pela IA, com retorno estimado.",
    icon: SparklesIcon,
    route: ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[1],
  },
];

// página "hub" de Mercados & Conveniências — cartões de entrada para os módulos de sortimento do varejo alimentar
export function MercadosConvenienciasScreen() {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <Default fullPage>
      <div style={{
        padding: "16px 28px", backgroundColor: SYSTEM_COLORS.WHITE.ALABASTER,
        display: "flex", flexDirection: "column", flex: 1, minHeight: 0,
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box", width: "calc(100% - 72px)", overflowY: "auto", overflowX: "hidden",
        marginLeft: 72,
      }}>
        {/* título — mesmo estilo das telas de Qualificação de MIX / Oportunidades de Sortimento */}
        <hgroup style={{ marginBottom: 20, flexShrink: 0 }}>
          <p style={{ fontSize: "11px", fontWeight: "700", color: "#999", letterSpacing: "0.6px", textTransform: "uppercase", margin: "0 0 6px" }}>
            Sortimento
          </p>
          <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#1a1a1a", margin: 0, letterSpacing: "-0.3px" }}>
            Mercados & Conveniências
          </h1>
          <p style={{ fontSize: "13px", color: "#999", margin: "3px 0 0" }}>
            Módulos de sortimento para o varejo alimentar e conveniência.
          </p>
        </hgroup>

        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
          {HUB_CARDS.map((card) => (
            <div
              key={card.title}
              onClick={() => navigate(card.route)}
              onMouseEnter={() => setHoveredCard(card.title)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{
                flex: "1 1 260px", minWidth: 260, maxWidth: 420, cursor: "pointer",
                backgroundColor: "#fff", borderRadius: "14px",
                border: `1px solid ${hoveredCard === card.title ? "#ED701D" : "#e5e5e3"}`,
                transition: "border-color 0.2s ease",
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)", padding: "24px",
              }}
            >
              <div style={{
                width: 44, height: 44, borderRadius: "10px", backgroundColor: "#fbe6d6",
                color: "#ED701D", display: "flex", alignItems: "center", justifyContent: "center",
                marginBottom: 16,
              }}>
                {card.icon}
              </div>
              <h2 style={{
                display: "flex", alignItems: "center", gap: "6px",
                fontSize: "16px", fontWeight: "700", color: "#1a1a1a", margin: "0 0 8px",
              }}>
                {card.title}
                <span style={{ color: "#ED701D", display: "flex" }}>{ArrowIcon}</span>
              </h2>
              <p style={{ fontSize: "13px", color: "#666", margin: 0, lineHeight: 1.5 }}>
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Default>
  );
}
